import { render, staticRenderFns } from "./TakeOver.vue?vue&type=template&id=512415f5&scoped=true&"
import script from "./TakeOver.vue?vue&type=script&lang=ts&"
export * from "./TakeOver.vue?vue&type=script&lang=ts&"
import style0 from "./TakeOver.vue?vue&type=style&index=0&id=512415f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512415f5",
  null
  
)

export default component.exports